import {Injectable} from "@angular/core";
import {SimpleCacheService} from "./simpleCache.service";
import {Pageable} from "../../../../shared/model/core/pageable.model";

@Injectable({providedIn: 'root'})
export class PaginationCacheService {

    constructor(private simpleCacheService: SimpleCacheService) {

    }

    public put(key: string, value: Pageable) {
        this.simpleCacheService.put(this.buildKey(key), value);
    }

    public getValue(key: string): Pageable {
        return this.simpleCacheService.getValue(this.buildKey(key));
    }


    private buildKey(key: string) {
        return 'pagaable_' + key;
    }
}